import BrowserDetection from './browserDetection';
/**
 *
 * BrowserDetection object is immediately executed when the page loads.
 * This Object is used to detect the browser and version the user is using.
 *
 * @namespace LocalStorageUtil
 */
'use strict';

let TWO_MEGA_BYTES = 2 * 1024 * 1024;
let FIVE_MEGA_BYTES = 5 * 1024 * 1024;
let TEN_MEGA_BYTES = 10 * 1024 * 1024;

// ---------------------------------------------
//
//        Define all public methods.
//
// ---------------------------------------------
var publicMethods = {
    /**
     * Return the remaining local storage in bytes.
     * @returns {number}
     */
    getRemainingLocalStorage: function () {
        // Return amount of unused local storage in bytes.
        let localStorageUsedSize = publicMethods.getLocalStorageUsedSize();
        let localeStorageSize;

        // sizes according to https://www.sitepoint.com/html5-local-storage-revisited/
        if (BrowserDetection.isMobile()) {
            if (nuskin.util.MobileUtils.isAndroidBrowserTheNativeAndroidBrowser()) {
                localeStorageSize = TWO_MEGA_BYTES;
            } else if (nuskin.util.MobileUtils.isIOS()) {
                localeStorageSize = FIVE_MEGA_BYTES;
            } else {
                localeStorageSize = TEN_MEGA_BYTES;
            }
        } else if (BrowserDetection.isSafari()) {
            localeStorageSize = FIVE_MEGA_BYTES;
        } else {
            localeStorageSize = TEN_MEGA_BYTES;
        }
        return localeStorageSize - localStorageUsedSize;
    },

    /**
     * Return the total local storage used in bytes.
     * @returns {number}
     */
    getLocalStorageUsedSize: function () {
        let totalKeyValuePairLengths = 0;
        let keyValuePairLength;
        let key;
        for (key in localStorage) {
            if (localStorage.hasOwnProperty(key)) {
                keyValuePairLength = publicMethods.getByteLength(key + localStorage[key]);
                totalKeyValuePairLengths += keyValuePairLength;
            }
        }

        return totalKeyValuePairLengths;
    },

    getByteLength: function (str) {
        // returns the byte length of an utf8 string
        let s = str.length;
        for (let i = str.length - 1; i >= 0; i--) {
            let code = str.charCodeAt(i);
            if (code > 0x7f && code <= 0x7ff) s++;
            else if (code > 0x7ff && code <= 0xffff) s += 2;
            if (code >= 0xDC00 && code <= 0xDFFF) i--; //trail surrogate
        }
        return s;
    }
};

export default publicMethods;
